import { render, staticRenderFns } from "./TagCount.vue?vue&type=template&id=7e1a4a1d&"
import script from "./TagCount.vue?vue&type=script&lang=ts&"
export * from "./TagCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports